import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companySearch = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/search',

        module: 'parts',
        keyword: '',
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        module: state => state.module,

        keyword: state => state.keyword,
    },
};
